import React from 'react';
import { ViewId, NAV_ITEMS } from '../../types/navigation';

interface NavigationProps {
  currentView: ViewId;
  onViewChange: (view: ViewId) => void;
  className?: string;
}

export const Navigation: React.FC<NavigationProps> = ({
  currentView,
  onViewChange,
  className = '',
}) => {
  const activeView = currentView === 'archive' ? 'treatises' : currentView;

  return (
    <nav className={`flex items-center gap-1 lg:gap-2 ${className}`} aria-label="Main Sanctuary Navigation">
      {NAV_ITEMS.map((item) => {
        const isActive = activeView === item.id || (item.id === 'treatises' && currentView === 'archive');
        return (
          <button
            key={item.id}
            onClick={() => onViewChange(item.id)}
            className={`relative px-3 py-2 text-xs lg:text-sm font-display tracking-wide uppercase transition-all duration-200 rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-bright/60 ${
              isActive
                ? 'text-gold-bright font-semibold'
                : 'text-parchment-dim hover:text-parchment-light hover:bg-obsidian-surface/40'
            }`}
            aria-current={isActive ? 'page' : undefined}
          >
            {item.label}
            {isActive && (
              <span className="absolute bottom-0 left-2 right-2 h-[2px] bg-gradient-to-r from-transparent via-gold-bright to-transparent shadow-glow-gold" />
            )}
          </button>
        );
      })}
    </nav>
  );
};
